import React, { useRef, useEffect, useState } from "react"
import "./Tooltip.css"

function Tooltip({ tooltip }) {
  const tooltipEl = useRef(null)

  const [contentStyle, setContentStyle] = useState({})
  useEffect(() => {
    const handleResize = () => {
      if (tooltipEl && tooltipEl.current) {
        const parent = tooltipEl.current
        const diff = window.outerWidth / 2 - parent.offsetLeft
        setContentStyle({
          left: window.outerWidth < 400 ? diff : "50%"
        })
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div ref={tooltipEl} className="tooltip">
      <span className="tooltip-button">[?]</span>
      <span style={contentStyle} className="tooltip-content">
        {tooltip}
      </span>
    </div>
  )
}

export default Tooltip
